module.exports = __webpack_public_path__ + "56b496f258397cb27142b367c6272505.svg";